import { config } from '@/lib/config';
import { buildWooCommerceOAuthUrls } from '@/lib/woocommerce-oauth-url';

export function buildWooCommerceOAuthUrl(params: {
  shopUrl: string;
  storeId: string;
  accountId: string;
  returnUrl: string;
}): string {
  const callbackBaseUrl = import.meta.env.VITE_LOCAL_TUNNEL_BASE_URL ?? config.apiBaseUrl;
  return buildWooCommerceOAuthUrls({
    shopUrl: params.shopUrl,
    storeId: params.storeId,
    accountId: params.accountId,
    targetReturnUrl: params.returnUrl,
    callbackBaseUrl,
    apiBaseUrl: config.apiBaseUrl,
  }).authUrl;
}
